import { render, staticRenderFns } from "./QuestionnaireView.vue?vue&type=template&id=2b69f5be&scoped=true"
import script from "./QuestionnaireView.vue?vue&type=script&lang=ts"
export * from "./QuestionnaireView.vue?vue&type=script&lang=ts"
import style0 from "./QuestionnaireView.vue?vue&type=style&index=0&id=2b69f5be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b69f5be",
  null
  
)

export default component.exports